import { CALLS_TO_ACTION_EDIT_SCOPE, CALLS_TO_ACTION_READ_SCOPE, CTA_ACCESS_SCOPE } from '../constants/Scopes';
export const checkAccessToLegacyCtas = ({
  scopes
}) => scopes.includes(CTA_ACCESS_SCOPE);
export const hasCtasReadScope = ({
  scopes
}) => scopes.includes(CALLS_TO_ACTION_READ_SCOPE);
export const hasCtasEditScope = ({
  scopes
}) => scopes.includes(CALLS_TO_ACTION_EDIT_SCOPE);
export const checkAccessToCtas = hasCtasReadScope;